//引入外部模組
import 'jquery-easing/jquery.easing.1.3';
import {BodyCtrl} from '@/body_ctrl';




//引入外部模組
let bodyCtrl = new BodyCtrl;




//視窗右下角固定工具列
class FixedTools {
  constructor(){
    this.window           = $(window);
    this.fixedTools       = $('#fixedTools');
    this.scrollTopBtn     = this.fixedTools.find('.scrollTopBtn');
    this.onlineServiceBtn = this.fixedTools.find('.onlineServiceBtn');
    this.onlineServiceTip = this.onlineServiceBtn.find('.tip');
    this.onlineService    = $('#onlineService');
    this.serviceContant   = this.onlineService.find('.contant');
    this.headerP          = $('#personalHeader');
    this.infoFixed        = $('#personalInfoFixed');
  }
  tools() {
    //工具列顯示 & 隱藏
    let showHide = () => {
      (this.window.scrollTop() > 100)? this.scrollTopBtn.show() : this.scrollTopBtn.hide();
    }
    showHide();

    //RWD 業務個人資訊
    let rwdPersonal = () => {
      if(window.matchMedia('(max-width: 1023px)').matches){
        let bottomPosition = (position) => {
          this.fixedTools.css('bottom', this.infoFixed.outerHeight() + position);
          if(this.headerP.length != 0){
            if(this.infoFixed.is('.hide')){
              if(this.infoFixed.is('.active')){
                this.fixedTools.css('bottom', this.infoFixed.outerHeight() + position);
              }else{
                this.fixedTools.css('bottom', position);
              }
            }
          }
        }
        if(window.matchMedia('(max-width: 600px)').matches){
          bottomPosition(10);
        }else{
          bottomPosition(20);
        }
      }else{
        this.fixedTools.css('bottom', '');
      }
    }
    rwdPersonal();

    this.window.on('scroll', () => {
      showHide();
      rwdPersonal();
    });
    //RWD 業務個人資訊
    this.window.on('resize', rwdPersonal);

    //回最上面
    this.scrollTopBtn.on('click', () => {
      bodyCtrl.ctrl('scrollHide'); //控制瀏覽器捲軸
      bodyCtrl.ctrl('btnLock');    //控制瀏覽器按鈕
      $('html, body').animate({
        scrollTop: 0
      }, 500, 'easeOutExpo', () => {
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('btnUnlock');  //控制瀏覽器按鈕
      });
      return false;
    });

    //線上客服提示初始顯示
    this.onlineServiceBtn.find('span').addClass('active');
    setTimeout(() => {
      this.onlineServiceBtn.find('span').removeClass('active');
    }, 5000);

    //線上客服
    if(this.onlineService.is('.login')){
      //開啟
      this.onlineServiceBtn.on('click', () => {
        this.onlineServiceTip.removeClass('active');
        this.onlineService.addClass('active');
        if(window.matchMedia('(max-width: 767px)').matches){
          if(this.onlineService.is('.active')){
            bodyCtrl.ctrl('scrollHide');  //控制瀏覽器捲軸
          }
        }else{
          bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        }
      });
      //關閉
      this.onlineService.find('.titleBar button').on('click', () => {
        this.onlineService.removeClass('active');
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
      });
      this.onlineService.find('.loginInfo button').on('click', () => {
        this.onlineService.removeClass('active');
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
      });
      //點擊外圍關閉
      $(document).on('click', () => {
        this.onlineService.removeClass('active');
      });
      this.onlineService.add(this.onlineServiceBtn).on('click', (e) => {
        e.stopPropagation();
      });

      //RWD
      let rwdOnlineService = () => {
        //控制瀏覽器捲軸
        if(this.onlineService.is('.active')){
          if(window.matchMedia('(max-width: 767px)').matches){
            bodyCtrl.ctrl('scrollHide');
          }else{
            bodyCtrl.ctrl('scrollShow');
          }
        }
        //對話框長度
        if(window.matchMedia('(max-width: 767px)').matches){
          this.serviceContant.find('ul').css('height' ,'');
        }else{
          this.serviceContant.find('ul').css('height', $(window).height() / 2.5);
        }
      }
      rwdOnlineService();
      this.window.on('resize', rwdOnlineService);
    }
  }
}




//輸出
export {FixedTools};


// WEBPACK FOOTER //
// ./js_new/fixed_tools.js